import React from 'react';
import Typography from '@hpstellar/core/Typography';

import './pdp-section.less'

export default ({ title='', children, showTitle=true, className }) => {
    return <div className={`pdp-section${className ? ` ${className}`:''}`} id={title.toLowerCase()}>
        {showTitle && <Typography variant='headingTitleMedium' tag='h2' className={'section-title'}>{title}</Typography>}
        {children}
    </div>
}